package ui.campaign.detailv2.widgets

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Chevron_right
import compose.assets.svg.Device
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__summary_devices_days
import ssoft.frontend.generated.resources.layer_top_detail_editor__summary_devices_impressions
import ssoft.frontend.generated.resources.layer_top_detail_editor__summary_devices_label
import tools.rememberString
import ui.widget.Space
import kotlin.math.roundToLong


@Composable
fun CampaignInfoCardDevices(
    showCounters: Boolean,
    locations: List<ImplCampaignInfoCard.Location>,
    onClickLocation: ((id: Long) -> Unit)? = null,
    onClickDevice: ((id: Long) -> Unit)? = null
) {
    if (onClickDevice != null) {
        CampaignInfoCardDevicesInteractive(
            locations = locations,
            onClickLocation = onClickLocation,
            onClickDevice = onClickDevice
        )
    } else {
        CampaignInfoCardDevicesStatic(
            showCounters = showCounters,
            locations = locations
        )
    }
}

@Composable
private fun CampaignInfoCardDevicesStatic(
    showCounters: Boolean,
    locations: List<ImplCampaignInfoCard.Location>,
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceContainer
        )
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier.fillMaxWidth().padding(16.dp),
        ) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Icon(Svg.Device, null)
                ThreeFieldText(
                    weights = floatArrayOf(2F, 1F, 1F),
                    label = Res.string.layer_top_detail_editor__summary_devices_label.rememberString(),
                    messageCenter = Res.string.layer_top_detail_editor__summary_devices_days.rememberString(),
                    messageEnd = Res.string.layer_top_detail_editor__summary_devices_impressions.rememberString(),
                    messageStyle = MaterialTheme.typography.labelMedium,
                    showEndMsg = showCounters
                )
            }
            Column(
                verticalArrangement = Arrangement.spacedBy(4.dp),
                modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
            ) {
                locations.forEachIndexed { index, location ->
                    if (index == 0) Space(4.dp)
                    else {
                        Space(8.dp)
                        HorizontalDivider()
                        Space(2.dp)
                        HorizontalDivider()
                        Space(8.dp)
                    }
                    Row(
                        Modifier.fillMaxWidth()
                            .clip(CardDefaults.shape)
                            .padding(vertical = 4.dp)
                    ) {
                        Canvas(Modifier.size(6.dp).align(Alignment.CenterVertically)) {
                            drawCircle(Color.White, size.width / 2F)
                        }
                        Text(
                            text = location.name,
                            style = MaterialTheme.typography.labelSmall,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier.fillMaxWidth().padding(start = 4.dp)
                        )
                    }
                    location.devices.forEach { device ->
                        ThreeFieldText(
                            weights = floatArrayOf(2F, 1F, 1F),
                            label = device.name,
                            messageCenter = device.countUsableDays,
                            messageEnd = "${(device.impressionSum.toDouble() * 0.95).roundToLong()}",
                            showEndMsg = showCounters
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun CampaignInfoCardDevicesInteractive(

    locations: List<ImplCampaignInfoCard.Location>,
    onClickLocation: ((id: Long) -> Unit)? = null,
    onClickDevice: ((id: Long) -> Unit)? = null
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceContainer
        )
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp, vertical = 16.dp),
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier.padding(horizontal = 8.dp)
            ) {
                Icon(Svg.Device, null)
                Text(
                    text = Res.string.layer_top_detail_editor__summary_devices_label.rememberString(),
                    modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp)
                )
            }
            Column(
                modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
            ) {
                locations.forEachIndexed { index, location ->
                    if (index == 0) Space(4.dp)
                    else {
                        Space(8.dp)
                        HorizontalDivider()
                        Space(2.dp)
                        HorizontalDivider()
                        Space(8.dp)
                    }
                    Row(Modifier.fillMaxWidth()
                        .clip(CardDefaults.shape)
                        .clickable(onClickLocation != null) {
                            onClickLocation?.invoke(location.id)
                        }
                        .padding(4.dp)
                        .padding(horizontal = 4.dp)) {
                        Canvas(Modifier.size(6.dp).align(Alignment.CenterVertically)) {
                            drawCircle(Color.White, size.width / 2F)
                        }
                        Text(
                            text = location.name,
                            style = MaterialTheme.typography.labelSmall,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier.fillMaxWidth().padding(start = 4.dp)
                        )
                    }

                    location.devices.forEach { device ->
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                            modifier = Modifier.fillMaxWidth()
                                .clip(CardDefaults.shape)
                                .clickable(onClickDevice != null) {
                                    onClickDevice?.invoke(device.id)
                                }.padding(4.dp).padding(horizontal = 4.dp)
                        ) {
                            Text(
                                text = device.name,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.weight(1F)
                            )
                            Icon(
                                imageVector = Svg.Chevron_right,
                                contentDescription = null,
                                modifier = Modifier.align(Alignment.CenterVertically)
                            )
                        }
                    }
                }
            }
        }
    }
}